import axios from "axios";

export const getComments = data => {
  const requestUrl = `/data/comments`;
  let { target, owner, token, period } = data;
  let sort = [];

  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    target: target,
    owner: owner,
    access_token: token,
    period: period
  };
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};
export const getSlidesForComments = data => {
  const requestUrl = `/data/slides-list`;
  let { uen } = data;
  const fields = [];
  let sort = [];

  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    fields: fields.join(","),
    uen: uen
  };
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const saveComment = ({
  slideCommentId,
  owner,
  slideCode,
  target,
  content,
  period
}) => {
  const requestUrl = `/data/save/comment`;

  let formData = new FormData();
  slideCommentId && formData.append("SlideCommentId", slideCommentId);
  formData.append("target", target);
  formData.append("slideCode", slideCode);
  formData.append("owner", owner);
  formData.append("content", content);
  formData.append("period", period);

  return axios.post(requestUrl, formData);
};

export const deleteCommentApi = ids => {
  const requestUrl = `/data/delete-slide-comment`;

  let formData = new FormData();
  formData.append("ids", JSON.stringify(ids));

  return axios.post(requestUrl, formData);
};

export const saveVoiceComment = data => {
  const requestUrl = `/data/save/record`;

  let formData = new FormData();
  formData.append("target", data.target);
  formData.append("slideCode", data.slideCode);
  formData.append("owner", data.owner);
  formData.append("period", data.period);
  formData.append("duration", data.duration);
  formData.append("files[0]", data.voiceFile, "name.mp3");

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/PreparePresentation.js